import React, { useCallback } from 'react';
import Card from 'components/inputs/Card';
import { Formik, Form } from 'formik';
import { Row, Col } from 'react-bootstrap';
import Button from 'components/inputs/Button';
import * as Yup from 'yup';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as _ from 'lodash';
import { TRIGGER_MESSAGE } from 'actions/chargerOcpp';
import Select from 'components/inputs/Select';
import { useTranslation } from 'react-i18next';
import { GET_STATION_CHARGER_OPERATIONS, MANAGE_STATION_CHARGER_OPERATIONS } from 'components/common/constant';

const TriggerMessageForm = () => {
  const { chargerId } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const chargerDetailData = useSelector((state) => state.charger.chargerDetails);
  const rolePermissionData = useSelector((state) => state.manageRole.manageRoles);

  const getTriggerMessage = useCallback((data, resetForm) => {
    dispatch({
      type: TRIGGER_MESSAGE.REQUEST,
      payload: { data },
      cb: (res) => {
        if (res) {
          if (_.get(res, 'status') === 200) {
            toast.success('Trigger message successfully');
            resetForm();
          }
        }
      },
    });
  }, []);

  const getStationChargerOperations =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === GET_STATION_CHARGER_OPERATIONS),
      (data) => data.name
    );

  const manageStationChargerOperations =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === MANAGE_STATION_CHARGER_OPERATIONS),
      (data) => data.name
    );

  const TriggerMessageSchema = Yup.object().shape({
    connectorId: Yup.number().required(t('triggerMessageForm.connectorId')),
    requestedMessage: Yup.string().required(t('triggerMessageForm.requestedMessage')).max(100, t('triggerMessageForm.maxlimit')),
  });

  const initialValues = {
    connectorId: '',
    requestedMessage: '',
  };

  return (
    <React.Fragment>
      <div className="serverOperation-title-name">{t('triggerMessageForm.formTitle')}</div>
      <div className="serverOperation-content-wrapper">
        <Card className="serverOperation-form-main">
          <div className="serverOperation-form__block">
            <Formik
              initialValues={initialValues}
              validationSchema={TriggerMessageSchema}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                const formData = {
                  ...values,
                  id: chargerId,
                };
                getTriggerMessage(formData, resetForm);
                setSubmitting(false);
              }}
            >
              {({ values, errors, touched, handleSubmit, setFieldValue, isSubmitting }) => (
                <Form onSubmit={handleSubmit}>
                  <div className="serverOperation-form__inner">
                    <Row>
                      <Col>
                        <Select
                          isRequired
                          label={t('triggerMessageForm.requestLabel')}
                          type="name"
                          placeholder={t('placeHolder.selectRequest')}
                          options={[
                            { label: 'BootNotification', value: 'BootNotification' },
                            { label: 'DiagnosticsStatusNotification', value: 'DiagnosticsStatusNotification' },
                            { label: 'FirmwareStatusNotification', value: 'FirmwareStatusNotification' },
                            { label: 'Heartbeat', value: 'Heartbeat' },
                            { label: 'MeterValues', value: 'MeterValues' },
                            { label: 'StatusNotification', value: 'StatusNotification' },
                          ]}
                          value={values.requestedMessage}
                          name="requestedMessage"
                          onChange={(val) => {
                            setFieldValue('requestedMessage', val);
                            // Reset the connectorId value to null when requestedMessage changes
                            setFieldValue('connectorId', null);
                          }}
                          error={errors.requestedMessage && touched.requestedMessage ? errors.requestedMessage : null}
                        />
                      </Col>
                      <Col>
                        <Select
                          isRequired
                          label={t('triggerMessageForm.connectorName')}
                          placeholder={t('placeHolder.selectConnector')}
                          options={[
                            ...(values.requestedMessage === 'StatusNotification' || values.requestedMessage === 'MeterValues'
                              ? [{ label: '0', value: '0' }] // Add static option when StatusNotification or MeterValues is selected
                              : []),
                            ..._.map(_.get(chargerDetailData, 'plugs', []), (item) => {
                              return { label: `${item.name} - ${item.connector_id}`, value: item.connector_id };
                            }),
                          ]}
                          name="connectorId"
                          value={values.connectorId}
                          onChange={(val) => setFieldValue('connectorId', val)}
                          error={errors.connectorId && touched.connectorId ? errors.connectorId : null}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="serverOperation-save--btn--block">
                    {!_.isEmpty(manageStationChargerOperations) ||
                    (!_.isEmpty(getStationChargerOperations) && !_.isEmpty(manageStationChargerOperations)) ? (
                      <Button type="submit" className="serverOperation-save-btn save--btn" disabled={isSubmitting}>
                        {t('triggerMessageForm.button')}
                      </Button>
                    ) : (
                      <Button className="serverOperation-save-btn save--btn">{t('triggerMessageForm.button')}</Button>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
export default TriggerMessageForm;
